<div class="toast-container">
    <div
        *ngFor="let toast of toasts"
        class="toast"
        [class]="'toast-' + toast.level.toLowerCase()"
        [@slideIn]
        (@slideIn.done)="onAnimationDone(toast)"
    >
        <div class="toast-icon">
            {{ getIcon(toast.type) }}
        </div>

        <div class="toast-content">
            <h4>{{ toast.title }}</h4>
            <p>{{ toast.message }}</p>
        </div>

        <button class="toast-close" (click)="removeToast(toast.id)">
            ✕
        </button>
    </div>
</div>